import { render, staticRenderFns } from "./iSpringQuizForm.vue?vue&type=template&id=45be5c66&scoped=true&"
import script from "./iSpringQuizForm.vue?vue&type=script&lang=js&"
export * from "./iSpringQuizForm.vue?vue&type=script&lang=js&"
import style0 from "./iSpringQuizForm.vue?vue&type=style&index=0&id=45be5c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45be5c66",
  null
  
)

export default component.exports